export default __webpack_public_path__ + "static/media/Velocity-Home_111.7961833a.jpg";